// Module
var code = "<a ng-href=\"{{$ctrl.url}}\" class=\"btn event-button bth-btn\" ng-click=\"$ctrl.handleClick($event)\" target=\"_blank\" rel=\"noreferrer noopener\"> <span ng-transclude></span> </a> ";
// Exports
module.exports = code;